/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DocumentsDetailsAliases {
  AVATAR_0 = 'avatar-0',
  CHECKBOX_VALIDITY = 'checkbox-validity',
  CONTENT_FIELD_REFUSAL_OR_EXPIRATION_DATE = 'content-field-refusal-or-expiration-date',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_FIELD_EMISSION = 'date-field-emission',
  DATE_FIELD_VALIDITY = 'date-field-validity',
  DECK_DOCUMENTS = 'deck-documents',
  FETCH_DOCUMENTS = 'fetch-documents',
  FETCH_DOCUMENTS_MODAL = 'fetch-documents-modal',
  FIELD_AVATAR = 'field-avatar',
  FIELD_BUTTOM = 'field-buttom',
  FIELD_CHECKBOX = 'field-checkbox',
  FIELD_DISABLED = 'field-disabled',
  FIELD_EMISSION_DATE = 'field-emission-date',
  FIELD_EMISSION_DISABLED = 'field-emission-disabled',
  FIELD_GUIDANCE = 'field-guidance',
  FIELD_ICON = 'field-icon',
  FIELD_ISSUE_DATE = 'field-issue-date',
  FIELD_NO_DOC = 'field-no-doc',
  FIELD_REFUSAL = 'field-refusal',
  FIELD_UPLOADER = 'field-uploader',
  FIELD_VALIDITY = 'field-validity',
  FILE_UPLOADER = 'file-uploader',
  FORM_SEND_DOCS = 'form-send-docs',
  HPMS_CUSTOM_CARD_DOCUMENTS = 'hpms-custom-card-documents',
  IMAGE_0 = 'image-0',
  INPUT_2 = 'input-2',
  INPUT_EMISSION = 'input-emission',
  INPUT_VALIDITY = 'input-validity',
  MAPPER_1 = 'mapper-1',
  MODAL_DOCS = 'modal-docs',
  PANEL_DOCUMENTS = 'panel-documents',
  PANEL_MODAL_DOCUMENTS = 'panel-modal-documents',
  TEXT_1 = 'text-1',
  TEXT_3 = 'text-3',
  TEXT_GUIDANCE = 'text-guidance',
}
export { DocumentsDetailsAliases };
